import InlineCalendar from "PFComponents/calendar/inline_calendar";
import { Icon } from "PFComponents/icon";
import Tooltip from "PFComponents/tooltip/tooltip";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import MoveStartDateIllustration from "PFTheme/graphics/illustrations/illustration-move-start-date.svg";
import React from "react";
import { useTranslation } from "react-i18next";

import { usePastDaysLimit } from "../../../../hooks";
import css from "../bulk_update_modal.module.scss";

const BulkMoveTooltip = () => {
  const { t } = useTranslation(["bookingModule", "translation"]);
  return (
    <div className={css.tooltip}>
      <MoveStartDateIllustration />
      <Typography variant="labelRegular" tag="span">
        {t("bookingModule:selectMode.bulkOperationModal.actions.move.tooltip")}
      </Typography>
    </div>
  );
};

type BulkMoveActionProps = {
  date: string;
  setDate: React.Dispatch<React.SetStateAction<string>>;
};

export const BulkMoveAction = ({ date, setDate }: BulkMoveActionProps) => {
  const portalRef = React.useRef<HTMLDivElement>(null);
  const { t } = useTranslation(["bookingModule", "translation"]);
  const { utc, formatISODateTime, formatISODate } = useDateFormatter();
  const pastDaysLimit = usePastDaysLimit();

  return (
    <div className={css.actionRow} ref={portalRef}>
      <Typography variant="bodyBold" tag="span">
        {t("bookingModule:selectMode.bulkOperationModal.actions.move.title")}
      </Typography>
      <div className={css.action}>
        <Typography variant="bodyRegular" tag="span">
          {t("bookingModule:selectMode.bulkOperationModal.actions.move.label")}
        </Typography>
        <Tooltip content={<BulkMoveTooltip />}>
          <div>
            <Icon name="info" />
          </div>
        </Tooltip>
        <InlineCalendar
          selectedDate={utc(date)}
          handleChange={setDate}
          clearDate={formatISODateTime(utc().startOf("day"))}
          portalRef={portalRef}
          minDate={formatISODate(utc().subtract(pastDaysLimit, "days"))}
        />
      </div>
    </div>
  );
};
